import * as React from 'react';
import * as moment from "moment";
import { IDonor } from '@nkr/models/index';

interface IProps {
    index: number,
    data: IDonor,
}

const RemoteWorkupsNotBilledRow: React.FunctionComponent<IProps> = (props) => {
    var dateValid = moment(props.data.donationDate).isValid();

    var donationDate = "N/A";
    if(dateValid)
        donationDate = moment(props.data.donationDate).format('MM/DD/YYYY');

    return (
        <>
            <tr key={props.index}>
                <td>
                    <a href={`center/${props.data.centerId}/donor/${props.data.id}/profile/donor-data`} target='_blank'>
                    {props.data.alias}
                    </a>
                </td>
                <td>
                    <div>
                        {donationDate}
                    </div>
                </td>
            </tr>
        </>
    );
}

export default RemoteWorkupsNotBilledRow;